import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Card } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/IJOT.css";
import memberImage from "../assets/images/aiotaman.png";
import { BookOpen, FilePen, Mail, Phone } from "lucide-react";

const IJOT = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [ijotMembers, setIjotMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleIjotNotification = () => {
    window.open("https://aiota-live.s3.ap-south-1.amazonaws.com/updates/IJOT.pdf", "_blank");
  };
  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch IJOT members from backend
  const fetchIjotMembers = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/get-all-ijot-membersCMS`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("IJOT API Response:", result);

      // Access the data array from the response
      if (result.success && result.data && Array.isArray(result.data)) {
        // Filter only active members that are not deleted
        const activeMembers = result.data.filter(
          (member) => member.status === 1 && !member.isDeleted
        );
        setIjotMembers(activeMembers);
        console.log("Active IJOT members:", activeMembers);
      } else {
        console.error("Invalid response structure:", result);
        setError("Invalid data format received from server");
      }
    } catch (err) {
      console.error("Error fetching IJOT members:", err);
      setError(`Failed to load IJOT members: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIjotMembers();
  }, []);

  const reviewMembers = [
    {
      name: "Dr. Amitabh Dwivedi",
      country: "India",
      expertise: "Neurosciences, Assistive Technology",
    },
    {
      name: "Dr. Anita D. Gupta",
      country: "India",
      expertise: "Work Rehabilitation, Developmental Disability",
    },
    {
      name: "Dr. Anuradha V. Pai",
      country: "India",
      expertise: "Neuro-Musculoskeletal Sciences, Teaching Technology",
    },
    {
      name: "Dr. Ashley Jayapaul",
      country: "Singapore",
      expertise:
        "Child/Adolescent Mental Health, Adult Neurodevelopmental Disorders",
    },
    {
      name: "Dr. Bhoomiah Dharmiah Dasari",
      country: "United Kingdom",
      expertise: "Musculoskeletal Sciences, Research Methodology",
    },
    {
      name: "Dr. Chavan Shashidhar Rao",
      country: "Kuwait",
      expertise: "Developmental Disability",
    },
    {
      name: "Dr. Harsh Vardhan",
      country: "New Zealand",
      expertise: "Pervasive Developmental Disorders",
    },
    {
      name: "Dr. Jayashri S. Kale",
      country: "India",
      expertise: "Cardio-Pulmonary Sciences, Neuroscience",
    },
    {
      name: "Dr. Joseph K. Wells",
      country: "USA",
      expertise: "Community Based Health, Ethics & Management",
    },
    {
      name: "Dr. Jyothika N. Bijlani",
      country: "India",
      expertise: "Neuro-Developmental Disorders",
    },
    {
      name: "Dr. Kamal Narayan Arya",
      country: "India",
      expertise: "Neuroscience, Physical Rehabilitation",
    },
    {
      name: "Dr. Nandu Nandoskar",
      country: "Australia",
      expertise: "Ergonomics, Occupational Health and Safety",
    },
    {
      name: "Dr. Neeraj Mishra",
      country: "India",
      expertise: "Neurosciences, Developmental Disabilities",
    },
    {
      name: "Dr. Nimisha Panchmatia",
      country: "United Kingdom",
      expertise: "Onco Palliative Care and Rehabilitation",
    },
    {
      name: "Dr. Odette Gomes",
      country: "India",
      expertise: "Mental Health",
    },
    {
      name: "Dr. Pankaj Bajpai",
      country: "India",
      expertise: "Locomotor Disability & Developmental Disability",
    },
    {
      name: "Dr. Pratibha M. Vaidya",
      country: "India",
      expertise: "Hand Therapy, Pediatric Rehabilitation",
    },
    {
      name: "Dr. R. K. Sharma",
      country: "India",
      expertise: "Sports Injury, Hand Rehabilitation",
    },
    {
      name: "Dr. Sanjay K",
      country: "Singapore",
      expertise: "Neuro-Developmental Disorders, Sensory Processing Disorders",
    },
    {
      name: "Dr. Sanjeev Padankatti",
      country: "India",
      expertise: "Pediatric Rehabilitation, Geri-Care, Ergonomics",
    },
    {
      name: "Dr. Sebestina Anita Dsouza",
      country: "India",
      expertise: "Neuroscience, Ergonomics, Geri-Care",
    },
    {
      name: "Dr. Shailaja S. Jaywant",
      country: "India",
      expertise: "Developmental Disability, Musculoskeletal Sciences",
    },
    {
      name: "Dr. Shovan Saha",
      country: "India",
      expertise: "Hand Rehabilitation, Assistive Technology",
    },
    {
      name: "Dr. Sujata Missal",
      country: "India",
      expertise: "Neuroscience, Ergonomics",
    },
    {
      name: "Dr. Sunita Koutarapu",
      country: "India",
      expertise: "Musculoskeletal & Sports Sciences, Teaching Technology",
    },
    {
      name: "Dr. Vaithi M. Perumal",
      country: "Riyadh, Saudi Arabia",
      expertise: "Developmental Disability, Mental Health",
    },
    {
      name: "Dr. Vijay Suple",
      country: "Canada",
      expertise: "Community Based Rehabilitation, Physical Rehabilitation",
    },
    {
      name: "Dr. Zarine D. Ferzandi",
      country: "India",
      expertise: "Mental Health, Neurosciences",
    },
  ];

  const guestReviewMembers = [
    {
      sNo: "1",
      name: "Bernadette Nedelec, PhD, BSc OT (c), Erg. Director, Occupational Therapy Program; Associate Professor McGill University, School of Physical and Occupational Therapy 3654 Promenade Sir William Osler, Montreal, Quebec H3G 1Y5",
      country: "Montreal, Quebec, Canada",
      expertise:
        "Musculoskeletal and Hand Injuries/Disorders, (Particularly Burn Injuries) Occupational Health, Work and Ergonomic Sciences",
    },
    {
      sNo: "2",
      name: "Giedre Kavaliauskiene, PhD President of Lithuanian Association of Occupational Therapists; Head of Department of Medical Education, Klaipeda University, Lithuania",
      country: "Lithuania",
      expertise:
        "Mental Health Sciences Learning Disabilities, Pervasive Developmental Disorders & Inclusive Education",
    },
    {
      sNo: "3",
      name: "Liliana da Conceicao Teixeira, MSc Occupational Therapist, OT Lecturer at Polytechnic of Leiria; College of Health, Portugal",
      country: "Portugal",
      expertise:
        "Neurosciences and Neuro-Developmental Disorders Ethical, Legal and Forensic Sciences",
    },
    {
      sNo: "4",
      name: "Shih-Chen, Maggie, Fan, PhD Assistant Professor Department of Occupational Therapy; I-Shou University, Taiwan",
      country: "Taiwan",
      expertise: "Occupational Health, Work & Ergonomic Sciences Neurosciences",
    },
  ];

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="ijot-section">
            <Container>
              <h2 className="text-center ijot-heading mb-5">
                The Indian Journal of Occupational Therapy
              </h2>
              <p>
                All India Occupational Therapists' Association (AIOTA) is
                registered under Bombay Public Trust Act, Mumbai 1950-E-1118.
                (Website: www.aiota.org) AIOTA is the founder council member of
                the World Federation of Occupational Therapists (WFOT) (Website:
                www.wfot.org). Academic Council of Occupational Therapy (ACOT)
                is a constituent body of AIOTA, responsible for the maintenance
                of the standards of education and training in occupational
                therapy in India. The Indian Journal of Occupational Therapy
                (IJOT) is an official publication of AIOTA since 1955 and since
                1956 with ISSN to date, with Print ISSN No.: 0445-7706. The IJOT
                is registered with the Office of Registrar of News Papers of
                India vide Registration No: 1653/57. The Abbreviated Key Title
                for Citation is Indian J. Occup. Ther.
              </p>
              <Row className="d-flex justify-content-center mb-5">
                <Button
                  className="button-ijot"
                  onClick={handleIjotNotification}
                >
                  <FilePen />
                  IJOT NOTIFICATION - CALL FOR EDITORS
                </Button>
              </Row>
              <Row className="">
                <h5 className="fw-bold text-center">Editorial Board</h5>
              </Row>
{!loading && !error && ijotMembers.length === 0 && (
  <Row className="mt-4">
    <Col>
      <div className="text-center">
        <div className="no-data-message">
          <h5 className="text-muted">No IJOT members available at the moment.</h5>
          <p className="text-muted">Please check back later for updates.</p>
        </div>
      </div>
    </Col>
  </Row>
)}

{!loading && !error && ijotMembers.length > 0 && (
  <Row className="g-4 mt-4">
    {ijotMembers.map((member, index) => (
      <Col xs={12} sm={6} md={4} key={member._id || index} className="d-flex justify-content-center">
        <div className="ijot-member-card">
          {/* Image Wrapper */}
          <div className="ijot-image-wrapper">
            {/* Base Image */}
            <img
              src={member.file_url || memberImage}
              alt={member.name}
              className="ijot-base-image"
            />

            {/* Offset Overlay */}
            <div
              className="ijot-hover-overlay ps-5 pt-5"
              style={{
                backgroundImage: `linear-gradient(350deg, rgb(0, 68, 255, 0.5), rgb(0, 0, 0)), url(${member.file_url  || memberImage})`
              }}
            >
              <p className="mb-3"><BookOpen className="me-2"/> {member.address}</p>
              <div className="phone-group mb-3">
                <Phone className="phone-icon" />
                <div className="phone-numbers">
                  {member.mobile_number && <p>{member.mobile_number}</p>}
                  {member.telephone_number && <p>{member.telephone_number}</p>}
                </div>
              </div>
              <p><Mail className="me-2"/> {member.official_email}</p>
            </div>
          </div>

          {/* Member Info */}
          <div className="info">
            <h5>{member.name}</h5>
            <p>({member.designation})</p>
          </div>
        </div>
      </Col>
    ))}
  </Row>
)}
             

              {error && (
                <Row className="mt-4">
                  <Col>
                    <div className="text-center text-light">
                      <h3>Error: {error}</h3>
                      <button
                        className="glass-button mt-3"
                        onClick={fetchIjotMembers}
                      >
                        Retry
                      </button>
                    </div>
                  </Col>
                </Row>
              )}
			  
              {/* Review Board Table */}
              <Row className="mt-5">
                <Col>
                  <h5 className="text-center mb-3">Review Board Members</h5>
                  <h5 className="text-center mb-4">
                    Indian Journal of Occupational Therapy (IJOT) (April
                    2024-March 2028)
                  </h5>
                  <Card className="p-0 card-ijot">
                    <Table responsive className="ijot-table">
                      <thead>
                        <tr>
                          <th className="fw-normal">
                            NAME OF REVIEW BOARD MEMBER (IJOT)
                          </th>
                          <th className="fw-normal">COUNTRY</th>
                          <th className="fw-normal">
                            EXPERTISE FOR MANUSCRIPT REVIEW
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reviewMembers.map((member, index) => (
                          <tr key={index}>
                            <td>{member.name}</td>
                            <td className="text-muted">{member.country}</td>
                            <td className="text-muted">{member.expertise}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <p className="text-muted ms-3 ijot-table-note">
                      <small>
* Total 28 Review Board Members: 18 from India and 10 Overseas Members (2 UK, 1 USA, 1 Canada, 2 Singapore, 1 Australia, 1 New Zealand, 1 Kuwait and 1 Saudi Arabia)
                      </small>
                    </p>
                  </Card>
                </Col>
              </Row>

              {/* Guest Review Board Table */}
              <Row className="mt-5">
                <Col>
                  <h5 className="text-center mb-3">
                    IJOT Guest Review Board: January 2018 onward
                  </h5>
                  <Card className="p-0 card-ijot">
                    <Table responsive className="ijot-table">
                      <thead>
                        <tr>
                          <th className="fw-normal">
                            NAME, QUALIFICATION & AFFILIATION
                          </th>
                          <th className="fw-normal">COUNTRY & EMAIL</th>
                          <th className="fw-normal">
                            AREA OF EXPERTISE for REVIEW
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {guestReviewMembers.map((member, index) => (
                          <tr key={index}>
                            <td>{member.name}</td>
                            <td className="text-muted">{member.country}</td>
                            <td className="text-muted">{member.expertise}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {/* <p className="text-muted ms-3 ijot-table-note">
                      <small>
                        *Total 12 Review Board Members: 6 from India and 6
                        Overseas Members
                      </small>
                    </p> */}
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default IJOT;
